import { Component, EventEmitter, Input, Output } from '@angular/core';

import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { CommonService } from 'src/app/shared/utils/common.service';

@Component({
  selector: 'app-successful-create-lock',
  templateUrl: './successful-create-lock.component.html',
  styleUrls: ['./successful-create-lock.component.scss'],
})
export class SuccessfulCreateLockComponent {
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();

  readonly LANG_CONST = LANG_CONST;

  constructor(public commonService: CommonService, private localizationService: LocalizationService) {
    this.localizationService.setupLocalization();
  }

  /**
   * @description close modal by the help of dialgue reference
   * @returns void
   */
  closeDialog(): void {
    this.dialogRef?.close();
  }

  /**
   * @description navigate back button form previous step
   * @returns void
   */
  navigateBack(): void {
    this.stepperChange.emit((this.stepper += -1));
  }
}
